// Matches the legacy `PageHeader` component. Title + optional subtitle + actions.

import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  breadcrumbs?: string[];
}

export function PageHeader({
  title,
  subtitle,
  actions,
  breadcrumbs,
}: PageHeaderProps) {
  return (
    <div className="mb-6">
      {breadcrumbs && (
        <div className="font-mono text-[10px] text-dim mb-[6px] tracking-[0.05em]">
          {breadcrumbs.join(" / ")}
        </div>
      )}
      {/* Stack title/subtitle above actions on mobile so a long action
          button (e.g. "🔒 Plan limit reached") doesn't squash the title.
          Side-by-side from sm+ where there's horizontal room. */}
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4">
        <div className="min-w-0">
          <h1 className="font-display text-[22px] sm:text-[26px] font-bold text-content tracking-[0.02em] leading-[1.2]">
            {title}
          </h1>
          {subtitle && (
            <div className="font-mono text-[11px] text-muted mt-[6px]">
              {subtitle}
            </div>
          )}
        </div>
        {actions && <div className="flex gap-2 shrink-0 flex-wrap">{actions}</div>}
      </div>
    </div>
  );
}
